var React = require('react');

function Section2MobileMiddleLeftInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"29.0615","width":"26.7632","height":"26.7632","transform":"rotate(23 29.0615 0)","fill":"#FEFCBE","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M53.2512 86.0053C55.109 92.9387 50.9944 100.065 44.0611 101.923C37.1277 103.781 30.0011 99.6663 28.1433 92.733C26.2856 85.7996 30.4001 78.673 37.3335 76.8152C44.2668 74.9574 51.3934 79.072 53.2512 86.0053Z","fill":"#F58C8C","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.0545 112.192L20.16 72.6507L43.4212 85.0189L14.0545 112.192Z","fill":"#E9D8FD","key":2})]);
}

Section2MobileMiddleLeftInline.defaultProps = {"width":"54","height":"113","viewBox":"0 0 54 113","fill":"none"};

module.exports = Section2MobileMiddleLeftInline;

Section2MobileMiddleLeftInline.default = Section2MobileMiddleLeftInline;
